import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  Grid,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  Paper,
} from "@mui/material";
import checkoutimg1 from "../assests/checkoutimg1.png";
import checkoutimg2 from "../assests/checkoutimg2.png";
import paycards from "../assests/paycards.png";
import { useAuthStore } from "../store/useAuthStore";
import CheckoutCart from "./CheckoutCart";
import { useCartStore } from "../store/useCartStore";
import { useOrderStore } from "../store/useOrderStore";
import PlacedOrderAnimation from "./PlacedOrderAnimation";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "./Loader/Loader";
import { useProductStore } from "../store/useProductStore";


const CheckoutForm = () => {

  const { authUser } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation();
  const throughCart = location.state?.throughCart;
  const { total, cart, resetCart } = useCartStore()
  const { placeOrder, loading } = useOrderStore()
  const { selectedproductToBuy } = useProductStore()
  const [formData, setFormData] = useState({
    fullName: authUser?.fullName,
    streetAddress: authUser?.address?.streetAddress,
    apartment: authUser?.address?.apartmentOrSuite,
    city: authUser?.address?.city,
    phone: authUser?.address?.phone,
    state: authUser?.address?.state,
    zipCode: authUser?.address?.zipCode,
    country: authUser?.address?.country,
  });
  const [isClicked, setIsClicked] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddressClick = () => {
    setIsClicked(true);

    // simulate click effect
    setTimeout(() => {
      setIsClicked(false);
    }, 150);
    console.log(authUser)
    setFormData((prev) => ({
      phone: "",
      streetAddress: "",
      fullName: "",
      apartment: "",
      city: "",
      state: "",
      zipCode: "",
      country: "United States",
    }));

    console.log(authUser?.address?.phone)
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("Form Data Submitted:", formData);
    try {
      let data
      if (throughCart) {
        data = await placeOrder(cart, formData, true)
        if (data) {
          resetCart();
        }
      }
      else {
        data = await placeOrder(selectedproductToBuy, formData, false)
      }

      if (data) {
        navigate("/success")
      }

    } catch (error) {
      console.log(error)
    }
  };
  return (
    <Grid container spacing={4}>
      <Grid item size={{ xs: 12, sm: 12, md: 7, lg: 7 }}>
        <Loader loading={loading} />
        <Typography sx={{
          fontSize: '28px',
          lineHeight: '30.8px',
          fontWeight: '700',
          fontFamily: `"Quicksand", sans-serif`,
          color: '#253D4E',
          paddingBottom: '10px',
          borderBottom: '1px solid #00000024',
          marginBottom: '15px',
          position: 'relative',
          '&::before': {
            content: `""`,
            width: '80px',
            height: '2px',
            background: '#008BFF',
            position: 'absolute',
            left: '0',
            bottom: '0',
          },
        }}>Billing Details</Typography>

        <Box
          component="form"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            flexWrap: "wrap",
            "& label": {
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "400",
              fontFamily: `"Lato", sans-serif`,
              color: "#000",
              marginBottom: "10px",
            },
            "& input": {
              height: "50px",
              paddingTop: "0",
              paddingBottom: "0",
            },
            "& .MuiFilledInput-root": {
              borderRadius: "4px",
            },
            "& .MuiInputBase-root.MuiFilledInput-root::before": {
              content: "none",
            },
            "& .MuiFormControl-root": {
              width: "100%",
            },
            "& input::placeholder": {
              color: "#999999",
            },
          }}
          noValidate
          autoComplete="off"
        >
          {authUser?.address && (
            <FormControl className="formControl" style={{ width: "97%" }}>
              <div
                onClick={handleAddressClick}
                style={{
                  width: "100%",
                  backgroundColor: isClicked ? "#c3e6cb" : "#d4edda",
                  height: "30px",
                  borderRadius: "5px",
                  padding: "12px",
                  cursor: "pointer",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontWeight: "500",
                  color: "#155724",
                  border: "1px solid #c3e6cb",
                  transition: "all 0.2s ease-in-out",
                  transform: isClicked ? "scale(0.98)" : "scale(1)",
                  boxShadow: isClicked ? "inset 0 0 4px rgba(0,0,0,0.2)" : "none",
                }}
                title="Use this address"
              >
                📍 Use another address:
              </div>
            </FormControl>
          )}

          <FormControl className="formControl">
            <label>
              Name<span>*</span>
            </label>
            <TextField
              id="standard-basic"
              name="fullName"
              placeholder="Md"
              type="text"
              variant="filled"
              value={formData.fullName}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="formControl">
            <label>
              Street Address <span>*</span>
            </label>
            <TextField
              id="standard-basic"
              name="streetAddress"
              type="text"
              variant="filled"
              value={formData.streetAddress}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="formControl">
            <label>Apartment, floor, etc. (optional)</label>
            <TextField
              id="standard-basic"
              name="apartment"
              placeholder="Kingston, 5236, United States"
              type="text"
              variant="filled"
              value={formData.apartment}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="formControl">
            <label>
              Town/City<span>*</span>
            </label>
            <TextField
              id="standard-basic"
              name="city"
              type="text"
              variant="filled"
              value={formData.city}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="formControl">
            <label>
              State<span>*</span>
            </label>
            <TextField
              id="standard-basic"
              name="state"
              type="text"
              variant="filled"
              value={formData.state}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="formControl">
            <label>
              ZipCode <span>*</span>
            </label>
            <TextField
              id="standard-basic"
              name="zipCode"
              type="number"
              variant="filled"
              value={formData.zipCode}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="formControl">
            <label>
              Phone Number <span>*</span>
            </label>
            <TextField
              id="standard-basic"
              name="phone"
              type="number"
              variant="filled"
              value={formData.phone}
              onChange={handleChange}
            />
          </FormControl>
        </Box>

        <FormControl className="formControl" sx={{ marginTop: "20px" }}>
          <FormControlLabel
            control={<Checkbox defaultChecked />}
            label="Save this information for faster check-out next time"
          />
        </FormControl>
      </Grid>


      <Grid item size={{ xs: 12, sm: 12, md: 5, lg: 5 }}>
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: '4px',
            border: '1px solid #ECECEC',
            boxShadow: '5px 5px 15px 0px #0000000D',
            padding: "10px 20px 20px",
            '& .productlist-check': {
              padding: "0",
            },
            "& .productlist-check li": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "15px",
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 400,
              lineHeight: "24px",
              fontSize: { xs: "16px", md: "22px", lg: "16px" },
              color: "#000",
            },
            "& .productlist-check li span": {
              display: "flex",
              alignItems: "center",
            },
            "& .productlist-check li .checkoutimg": {
              marginRight: "20px",
            },
          }}
        >
          {
            throughCart ?
              <CheckoutCart cart={cart} /> :
              <CheckoutCart cart={selectedproductToBuy} />
          }
          <ul className="productlist-check " style={{ backgroundColor: '#f7f5f5', borderRadius: "4px", padding: '10px' }}>
            {/* <li>
              <span>
                <img src={checkoutimg1} alt="product-img" className="checkoutimg" />
                Masks Pack of 500pcs
              </span>
              <span>
                $650
              </span>
            </li>
            <li>
              <span>
                <img src={checkoutimg2} alt="product-img" className="checkoutimg" />
                Methylated Sirits 2000 ml
              </span>
              <span>
                $1100
              </span>
            </li> */}

            <li>
              <b>
                Subtotal:
              </b>
              <b>
                {
                  throughCart
                    ? `${total != null ? total : 'NA'}`
                    : `${selectedproductToBuy[0]?.total != null ? selectedproductToBuy[0]?.total : 'NA'}`
                }

              </b>
            </li>
            <hr />
            <li>
              <b>
                Shipping:
              </b>
              <b>
                Free
              </b>
            </li>
            <hr />
            <li>
              <b>
                Total:
              </b>
              <b>
                {
                  throughCart
                    ? `${total}`
                    : `${selectedproductToBuy[0]?.total}`
                }
              </b>
            </li>
            {/* <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <li>
                <span>
                  <FormControlLabel value="female" control={<Radio />} label="Female" />
                </span>
                <span>
                  <img src={paycards} alt="product-img" className="checkoutimg" />
                </span>
              </li>
              <li>
                <span>
                  <FormControlLabel value="male" control={<Radio />} label="Male" />
                </span>
              </li>
            </RadioGroup> */}
          </ul>
          <Box
            sx={{
              marginTop: "30px",
            }}
          >
            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={{
                display: "block",
                textAlign: "center",
                background: "rgb(45, 60, 103)",
                width: "100%",
                height: {
                  xs: "36px",
                  sm: "36px",
                  md: "45px",
                  lg: "56px",
                },
                borderRadius: "4px",
                color: "#FAFAFA",
                boxShadow: "none",
                fontWeight: 600,
                fontSize: {
                  xs: "12px",
                  sm: "15px",
                  md: "15px",
                  lg: "16px",
                },
                lineHeight: {
                  xs: "18px",
                  sm: "20px",
                  md: "22px",
                  lg: "24px",
                },
                textTransform: "capitalize",
              }}
            >
              Place Order
            </Button>
          </Box>
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            marginTop: "30px",
            "& .coupenCode": {
              fontSize: "16px",
              lineHeight: "24px",
              marginRight: "30px",
              color: "#000",
              border: "1px solid #C6C4C4",
              borderRadius: "4px",
              width: "100%",
              height: "56px",
            },
            "& .MuiInputBase-root.MuiInput-root": {
              height: "100%",
              padding: "0 15px",
            },
            "& .MuiInputBase-root.MuiInput-root::before": {
              content: "none",
            },
          }}
        >
          <TextField
            className="coupenCode"
            id="coupenCode"
            placeholder="Coupen Code"
            type="text"
            variant="standard"
          />
          <Button
            variant="contained"
            sx={{
              display: "block",
              textAlign: "center",
              background: "#008BFF",
              width: "202px",
              height: {
                xs: "36px",
                sm: "36px",
                md: "45px",
                lg: "56px",
              },
              borderRadius: "4px",
              color: "#FAFAFA",
              boxShadow: "none",
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 500,
              fontSize: {
                xs: "12px",
                sm: "15px",
                md: "15px",
                lg: "16px",
              },
              lineHeight: {
                xs: "18px",
                sm: "20px",
                md: "22px",
                lg: "24px",
              },
              textTransform: "capitalize",
            }}
          >
            Apply Coupon
          </Button>
        </Box> */}

      </Grid>
    </Grid>
  );
};

export default CheckoutForm;
